export default {
  en: {
    actions: {
      cancel: 'Cancel',
    },
  },
};
